// ============================================================
// caseSummary.ts
// Shared RawCase → CaseSummary narrowing for the case quick-view modal.
// Used by the case list (Back re-open of the quick view) and the client
// search cards (case chip → quick view), so both seed the modal the same way.
// ============================================================
import type { RawCase } from '../types/case.types'
// Type-only (erased at runtime — no import cycle with the list component).
import type { CaseSummary } from '../components/layout/CaseListScreen'

// Map a full RawCase → the trimmed CaseSummary the list rows + quick modal
// use. Used to re-seed the quick-view modal on a Back-restore when the case
// isn't in the currently-loaded page (e.g. it was on a different page). RawCase
// is a superset of CaseSummary, so this just narrows to the fields we display.
export const rawToSummary = (r: RawCase): CaseSummary => ({
  id: r.id,
  caseName: r.caseName ?? null,
  defendantName: r.defendantName ?? null,
  client: r.client ?? null,
  clientForename: r.clientForename,
  clientSurname: r.clientSurname,
  clientDateOfBirth: r.clientDateOfBirth,
  clientNiNumber: r.clientNiNumber,
  clientMainContactNumber: r.clientMainContactNumber,
  clientEmailAddress: r.clientEmailAddress,
  accidentDate: r.accidentDate,
  accidentLocation: r.accidentLocation,
  claimantReg: r.claimantReg,
  openDate: r.openDate,
  closeDate: r.closeDate,
  setupFinalised: r.setupFinalised,
  createdAt: r.createdAt,
  updatedAt: r.updatedAt,
  completedSections: r.completedSections,
  assignedToUserId: r.assignedToUserId,
  assignedTo: r.assignedTo
    ? { id: r.assignedTo.id, firstName: r.assignedTo.firstName, lastName: r.assignedTo.lastName }
    : null,
  firmWide: r.firmWide ?? false,
  assignees: r.assignees ?? [],
  claimType: r.claimType ?? null,
  hasLimitationDate: r.hasLimitationDate,
  limitationDate: r.limitationDate,
})

